import 'bootstrap/dist/css/bootstrap.min.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './App'
import store from './redux/store'
import decryptJWT from './utils/decryptJWT'

function Index() {
  let id = window.location.host.includes('localhost')
    ? '70154f6b-cff8-44ca-9c4a-aa3ba78f3c3f'
    : 'b5b85e9a-1c9f-4f5a-ae83-ef96915891f6'

  window.OneSignal = window.OneSignal || []
  const OneSignal = window.OneSignal

  OneSignal.push(() => {
    OneSignal.init(
      { appId: id },
      OneSignal.sendTag('email', decryptJWT('login'), () => {})
    )
  })

  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

ReactDOM.render(<Index />, document.getElementById('root'))
